<template>
	<aside class="side-nav" ref="aside" :class="{ 'd-none': !usuarioLogado, 'd-flex': usuarioLogado }">
		<nav class="py-3 px-2 d-flex flex-column align-items-center navbar-aside no-scroll" ref="navbar-aside">
			<ul class="nav nav-body w-100 flex-column">
				<NavLink :openOnlyOneSubMenu="openOnlyOneSubMenu" v-for="link in linksPermitidos" :key="link.name" v-bind="link" @link="navClick"/>
			</ul>
			<div style="width: 100%; height: 100%; min-height: 3rem;">
				<div class="d-block">
					<div></div>
				</div>
			</div>
			<div
				class="btn-exit"
				@click="logout()"
			>
				<LogOutIcon/>
				Sair
			</div>
		</nav>

		<div v-if="!sideBarOnlyExpanded" class="splitter d-flex flex-column justify-content-center align-items-center" :class="{'is-expanded': !isBarMinimized}" @mousedown.prevent="startResize">
			<div class="handle w-100 h-100"></div>
			<svg class="arrow" id="toggleSizeAsideNav" @click.stop="toggleNavBar" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
				<path d="M9.984 6l6 6-6 6-1.406-1.406 4.594-4.594-4.594-4.594z"></path>
			</svg>
		</div>
	</aside>
</template>

<style scoped>
	.feather-dashboard {
		fill: currentColor !important;
	}

	.navbar-aside {
		width: 70px;
		overflow-y: auto;
	}

	.side-nav {
		transform: translateX(-100%) translateX(-30px);
	}

	.navbar-aside.animw {
		transition: width 0.3s ease-in-out;
	}
	.navbar-aside .nav {
		display: block;
	}
	.nav-link {
		text-overflow: ellipsis;
	}

	.splitter svg path {
		transition: transform 0.3s ease-in-out;
	}
	.splitter.is-expanded svg path {
		transform: scaleX(-1) translateX(-100%);
	}

	nav::-webkit-scrollbar {
		width: 3px;
		height: 3px;
	}

	nav::-webkit-scrollbar-track {
		background: var(--cal-header-color);
	}

	nav::-webkit-scrollbar-thumb {
		background-color: #fff;
		border-radius: 20px;
	}

	.btn-exit {
		border-radius: 10px;
		align-content: center;
		width: 100%;
		min-height: 2.75rem !important;
		padding-left: 1rem;
		display: block;
		z-index: 999;
		margin: 0 7px;
		cursor: pointer;
		color: white;
	}

	.btn-exit:hover {
		background-color: rgb(255, 0, 0, 0.9);
		color: #fff;
	}

	@media (max-width: 768px) {
		.btn-exit {
			min-height: calc(var(--mobile-height-btn-menu-sidebar) + 1rem) !important;
			font-size: 1.25rem;
			align-content: center;
		}
	}
</style>

<script>
	import { mapState } from "vuex";

	import NavLink from "@/components/NavBar/NavLink";
	import { AuthService } from "../services/auth";

	export default {
		components: { NavLink },

		data () {
			return {
				isBarMinimized: true, // Árvores
				originalWidth: 72,
				originalX: 0,
				originalMouseX: 0,
				minWidth: 0,
				refNav: "navbar-aside",
				userPermissions: [],
				sideBarOnlyExpandedMaxWidth: 400,
				openOnlyOneSubMenu: true,
				authService: new AuthService()
			};
		},

		props: {
			maxWidth: Number,
			hidden: Boolean,
			sideBarOnlyExpanded: Boolean,
			links: {
				type: Array,
				default: () => []
			}
		},

		computed: {
			// Propriedade computada para filtrar os links segundo as permissões
			linksPermitidos: {
				get () {
					return this.filtraLinks(this.links, this.userPermissions);
				}
			},
			...mapState(["usuarioLogado"])
		},

		watch: {
			hidden: "setHiddenState",
			maxWidth: "setMaxWidth",
			"usuarioLogado" (newVal) {
				this.getPermissions();
			}
		},

		methods: {
			filtraLinks (links, permsUser) {
				return links.reduce((acc, item) => {
					const isItemPermitted = !item.showPerms || item.showPerms.some(perm => permsUser.includes(perm));

					if (!isItemPermitted) {
						return acc;
					}

					if (item.children) {
						const filteredChildren = this.filtraLinks(item.children, permsUser);

						if (filteredChildren.length > 0 || item.to) {
							const newItem = { ...item, children: filteredChildren };
							return [...acc, newItem];
						}
					} else {
						return [...acc, item];
					}

					return acc;
				}, []);
			},

			startResize (e) {
				const element = this.$refs[this.refNav];

				const resize = e => {
					const width = this.originalWidth + (e.pageX - this.originalMouseX);
					element.style.width = width + "px";
					this.isBarMinimized = width <= this.minWidth;
				};

				const stopResize = () => {
					window.removeEventListener("mousemove", resize);
					window.removeEventListener("mouseup", stopResize);
					this.$emit("resize", parseInt(window.getComputedStyle(element).width) + 2);
				};

				this.originalWidth = parseFloat(getComputedStyle(element, null).getPropertyValue("width").replace("px", ""));
				this.originalX = element.getBoundingClientRect().left;
				this.originalMouseX = e.pageX;
				window.addEventListener("mousemove", resize);
				window.addEventListener("mouseup", stopResize);
			},

			toggleNavBar () {
				const element = this.$refs[this.refNav];

				this.originalWidth = parseFloat(getComputedStyle(element, null).getPropertyValue("width").replace("px", ""));
				element.classList.add("animw");

				if (this.originalWidth > this.minWidth) {
					// Minimize
					element.style.width = this.minWidth + "px";
					this.isBarMinimized = true;
				} else {
					// Maximize
					element.style.width = this.maxWidth + "px";
					this.isBarMinimized = false;
				}

				this.$emit("resize", parseInt(element.style.width) + 2);
				setTimeout(() => element.classList.remove("animw"), 300);
			},

			maximize () {
				const element = this.$refs[this.refNav];
				element.style.width = !this.sideBarOnlyExpanded ? this.maxWidth + "px" : this.sideBarOnlyExpandedMaxWidth + "px" ;
				this.isBarMinimized = false;
			},

			setHiddenState () {
				const aside = this.$refs.aside;
				if (this.hidden) {
					// Oculta barra deslizando-a para a esquerda
					aside.style.transform = "translateX(-100%) translateX(-30px)";
				} else {
					// Mostra barra deslizando-a para a direita
					aside.style.transform = "translateX(0)";
				}
			},

			setMaxWidth () {
				const element = this.$refs[this.refNav];
				element.style.maxWidth = this.maxWidth + "px";
			},

			navClick () {
				this.$emit("link");
			},

			getPermissions () {
				this.userPermissions = localStorage.params ? (JSON.parse(localStorage.params).grupoUsuario).split(",") : [];
			},

			logout () {
				this.authService.logout();
			}
		},

		mounted () {
			const element = this.$refs[this.refNav];
			this.minWidth = !this.sideBarOnlyExpanded ? parseFloat(getComputedStyle(element, null).getPropertyValue("min-width").replace("px", "")) : this.sideBarOnlyExpandedMaxWidth + "px" ;
			this.setHiddenState();
			this.setMaxWidth();
			this.getPermissions();
			if (this.sideBarOnlyExpanded) this.maximize();
		}
	};
</script>
